export default __webpack_public_path__ + "static/media/front-vid.c1e8f141.mp4";